/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum ChargeStatus {
  OUTSTANDING = 'outstanding',
  PAID = 'paid',
  VOID = 'void',
  PENDING = 'pending',
}
